import { Form } from '@ant-design/compatible'

import ManageManufacturerForm from './ManageManufacturerForm'

export default Form.create({
  name: 'manufacturerForm',
})(ManageManufacturerForm)
